import { render, staticRenderFns } from "./part.vue?vue&type=template&id=4e9d49d8&scoped=true"
import script from "./part.vue?vue&type=script&lang=js"
export * from "./part.vue?vue&type=script&lang=js"
import style0 from "./part.vue?vue&type=style&index=0&id=4e9d49d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0__css-load_8f028cf8807308e2a605e975797e53c7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9d49d8",
  null
  
)

export default component.exports